import type { Period } from '@calculom/report-designer';

export const MOCK_PERIODS: Period[] = [
  { id: '2026-01', name: 'January 2026' },
  { id: '2026-02', name: 'February 2026' },
  { id: '2026-03', name: 'March 2026' },
  { id: '2026-04', name: 'April 2026' },
  { id: '2026-05', name: 'May 2026' },
  { id: '2026-06', name: 'June 2026' },
  { id: '2026-07', name: 'July 2026' },
  { id: '2026-08', name: 'August 2026' },
  { id: '2026-09', name: 'September 2026' },
  { id: '2026-10', name: 'October 2026' },
  { id: '2026-11', name: 'November 2026' },
  { id: '2026-12', name: 'December 2026' },
];
